import { useEffect, useRef } from 'react';
import { useClickAway } from 'react-use';

import { logEvent } from '../../lib/analytics';
import { redirectToOnboardingCheckout } from '../../lib/redirect';
import { useVoiceDemo } from '../../providers/VoiceDemoContext';
import { Close } from '../icons/close';
import { UpsellIcon } from '../icons/Upsell';

const upsellData = {
  upsellTitle: 'Unlock Premium Voice Over Features',
  upsellFeatures: [
    { feature: 'Access hundreds of premium voices', id: 'feature-001' },
    { feature: 'High-quality voice over export', id: 'feature-002' },
    { feature: 'Unlimited voice cloning', id: 'feature-003' },
    { feature: 'Professional editing tools', id: 'feature-004' },
  ],
  upsellCtaText: 'Upgrade Now',
};

export const UpsellModal = () => {
  const { showUpsell: visible, setShowUpsell: setVisible } = useVoiceDemo();
  const ref = useRef(null);
  useClickAway(ref, () => {
    setVisible(false);
  });

  useEffect(() => {
    if (visible) {
      logEvent('upsell_action', { action: 'displayed' });
    }
  }, [visible]);

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-2 transition-all duration-300 ${
        visible
          ? 'pointer-events-auto opacity-100'
          : 'pointer-events-none opacity-0'
      }`}>
      <div
        className={`max-w-100% relative w-[500px] rounded-2xl bg-white p-8 pt-[60px] transition-all duration-300 @md:p-12 ${
          visible
            ? 'translate-y-10 scale-100 opacity-100'
            : 'translate-y-0 scale-95 opacity-0'
        }`}
        style={{
          boxShadow: '0px 8px 24px 4px rgba(0, 0, 0, 0.20)',
        }}
        ref={ref}>
        <button
          className="absolute right-4 top-4 rounded-full p-[6px] hover:bg-glass200"
          onClick={() => {
            setVisible(false);
            logEvent('upsell_action', { action: 'dismissed' });
          }}>
          <Close />
        </button>
        <div className="flex flex-col items-center gap-4 @md:gap-6">
          <UpsellIcon />

          <h3 className="text-xl leading-[1.33] @md:text-[28px] @md:leading-[1.43]">
            {upsellData.upsellTitle}
          </h3>
          <ul className="">
            {upsellData.upsellFeatures.map((item) => (
              <li
                className="flex items-center gap-3 py-1 @md:py-[6px]"
                key={item.id}>
                <span>
                  <svg
                    width="15"
                    height="12"
                    viewBox="0 0 15 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1.29199 6.79392L4.90136 10.4033L13.708 1.59668"
                      stroke="#0FA51E"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                {item.feature}
              </li>
            ))}
          </ul>

          <button
            onClick={() => {
              logEvent('upsell_action', { action: 'clicked' });
              redirectToOnboardingCheckout();
            }}
            className="rounded-lg bg-black px-6 py-3 text-white">
            {upsellData.upsellCtaText}
          </button>
        </div>
      </div>
    </div>
  );
};
